import { HttpStatusCode } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { PageService } from 'src/app/core/page/page.service';
import { ValidatorsService } from 'src/app/core/validators/validators.service';
import { RawFormEmployerInqueryDto } from 'src/app/data/dtos';
import { selectColorTheme } from 'src/app/store/color-theme/selectors';
import { AppStateInterface } from 'src/app/store/types';
import { NgOptimizedImage, NgIf, NgClass, AsyncPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-employers',
    templateUrl: './employers.component.html',
    styleUrls: ['./employers.component.scss'],
    imports: [
        NgOptimizedImage,
        ReactiveFormsModule,
        NgIf,
        NgClass,
        AsyncPipe,
    ]
})
export class EmployersComponent {
  activeTheme$: Observable<string>;
  inquerySuccessfull: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  mustCheckDatenschutz: boolean = false;

  employerInquiryFrom = new FormGroup({
    companyName: new FormControl('', Validators.required),
    inquirer: new FormControl('', [Validators.required]),
    inquiredPosition: new FormControl('', [Validators.required]),
    city: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, this._validatorsService.emailPattern]),
    phoneNumber: new FormControl(),
    message: new FormControl(),
    dataPrivacyConcent: new FormControl(false, Validators.required),
  });

  constructor(
    private _store: Store<AppStateInterface>,
    private _pagerService: PageService,
    private _validatorsService: ValidatorsService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta
  ) {
    this.activeTheme$ = this._store.select(selectColorTheme);
  }

  ngOnInit() {
    this.setLanguageToGerman();
  }

  onFormSubmit() {
    const employerInquery = this.employerInquiryFrom.value as RawFormEmployerInqueryDto;
    if(!employerInquery.dataPrivacyConcent) {
      this.mustCheckDatenschutz = true;
      return;
    }
    this._pagerService.sendEmployerInquery(employerInquery).subscribe({
      next: result => {
        if(result && result.status === HttpStatusCode.Created)
        this.inquerySuccessfull.next(true);
        this.mustCheckDatenschutz = false
      },
      error: error => {
        console.log(error);
        this.inquerySuccessfull.next(false);
      }
    })

  }

  private setLanguageToGerman() {
    this._pagerService.setLanguage('de');
  }

  private initSEOContent() {
      this.activatedRoute.data.subscribe(() => {
        // Common meta tags
        const imageUrl = 'https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/almanjobs_logo_primary_98d1b23517.svg';
        this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
        this.metaService.updateTag({ name: 'viewport', content: 'width=device-width, initial-scale=1.0' });
        this.metaService.updateTag({ name: 'author', content: 'Almanjobs' });
        this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
        this.metaService.updateTag({ name: 'og:image', content: imageUrl });
        this.metaService.updateTag({ name: 'twitter:image', content: imageUrl });
        this.metaService.addTag({ rel: 'alternate', hreflang: 'x-default', href: `https://almanjobs.com/en` });

        this.titleService.setTitle('Almanjobs - Fachkräfte weltweit rekrutieren');
        this.metaService.updateTag({
          name: 'description',
          content: 'Suchen Sie qualifizierte Fachkräfte? Unsere Plattform verbindet Sie mit IT-Experten und Pflegekräften aus ganzer Welt',
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'Fachkräfte rekrutieren, IT-Spezialisten finden, Pflegekräfte finden, internationale Mitarbeiter, Fachkräfte Deutschland, Einwanderung für Arbeit',
        });
        this.metaService.updateTag({
          property: 'og:title',
          content: 'Almanjobs - Fachkräfte weltweit rekrutieren',
        });
        this.metaService.updateTag({
          property: 'og:description',
          content: 'Unsere Plattform verbindet Sie mit IT-Experten und Pflegekräften aus der ganzen Welt, die bereit sind, in Deutschland zu arbeiten.',
        });
        this.metaService.updateTag({
          property: 'og:url',
          content: `https://almanjobs.com/de/employers`,
        });
        this.metaService.addTag({ rel: 'alternate', hreflang: 'de', href: `https://almanjobs.com/de/employers` });
      });
  }
}
